import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttParticipantsList } from '../../../sporttia/all';
import { useCrud } from '../../../lib/hooks';

export default function EventTeam({ team, onDelete }: any) {
    const { t } = useTranslation();
    const [_team, setTeam, , , , , Delete] = useCrud(team);

    useEffect(() => {
        if (team && team.participants.length !== _team.participants.length) {
            setTeam(team);
        }
    }, [team]);

    function deleteParticipant(participant: any) {
        Delete(`/events/participants/${participant.id}`)
            .then(() => {
                onDelete();
            })
            .catch(() => {});
    }

    if (!team) {
        return null;
    }

    return (
        <>
            <Box mb={3}>
                <Typography>{_team?.name}</Typography>
                <Typography>{`${t('event.category')}: ${
                    _team.category?.name
                }`}</Typography>
            </Box>
            <Box mb={1}>
                <Typography>{t('event.participants')}:</Typography>
            </Box>
            <Box>
                <SttParticipantsList
                    participants={_team.participants}
                    onDelete={deleteParticipant}
                />
            </Box>
        </>
    );
}
